/* eslint-disable import/first */
import './vendors';
import ReactDOM from 'react-dom';
import { renderApp } from './renderApp';
import './fonts.css';
import { initializeTracking } from './lib/Tracking';
import { initializeSentry } from './lib/Sentry';

ReactDOM.render(
  renderApp({
    pkgVersion: document.body.dataset.pkgversion,
    version: document.body.dataset.version,
  }),
  document.getElementById('root'),
);

initializeTracking();
initializeSentry();
